"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverlayContextData = exports.useOverlay = exports.default = exports.OverlayProvider = exports.OverlayContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _index = require("../../_nextgen/packages/styled-component-themes/index");
var _analytics = _interopRequireWildcard(require("../../components/analytics"));
var _chronobreak = _interopRequireDefault(require("../../packages/chronobreak"));
var _redux = require("../../packages/redux");
var _scrollLock = require("../../packages/scroll-lock");
var _CloseButton = _interopRequireDefault(require("./CloseButton"));
var _index2 = _interopRequireWildcard(require("./index.ducks"));
var _index3 = _interopRequireDefault(require("./index.styled"));
var colors = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
let overlayLockCounter = 0;
let overlayMap = [];
const useOverlay = function (_ref) {
  let {
    id
  } = _ref;
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id,
    reducer: _index2.default,
    initialState: _index2.initialState,
    persist: true
  });
  const isShowingPage = select(_index2.getShowPage);
  return [function (context) {
    if (!overlayMap.includes(id)) {
      overlayMap.push(id);
    }
    if (context) {
      dispatch((0, _index2.showPageWithContext)(context));
    } else {
      dispatch(_index2.showPage);
    }
  }, function () {
    if (overlayMap.includes(id)) {
      overlayMap = overlayMap.filter(function (item) {
        return item !== id;
      });
    }
    dispatch(_index2.hidePage);
  }, isShowingPage];
};
exports.useOverlay = useOverlay;
const OverlayContext = exports.OverlayContext = /*#__PURE__*/_react.default.createContext({});
const useOverlayContextData = function () {
  return (0, _react.useContext)(OverlayContext);
};
exports.useOverlayContextData = useOverlayContextData;
const OverlayProvider = function (_ref2) {
  let {
    value,
    children
  } = _ref2;
  const inheritedData = (0, _react.useContext)(OverlayContext);
  const data = {
    ...inheritedData,
    ...value
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(OverlayContext.Provider, {
    value: data,
    "data-testid": "OverlayProvider",
    children: children
  });
};
exports.OverlayProvider = OverlayProvider;
const OverlayComponent = function (_ref3) {
  let {
    id = "OverlayComponent",
    pageSpacing = false,
    lightbox = false,
    fit = "cover",
    buttonTheme = "default",
    background = "#FFF",
    color = "#000",
    onClose,
    onOpen,
    children,
    hideClose = false,
    isSamePageOverlay = false,
    topPosition = 0,
    borderRadius = 0,
    src,
    closeOutside = false,
    closeButtonIconColor,
    closeButtonBackgroundColor,
    disableChronoBreak = false,
    ariaLabel,
    fixedHeight,
    width,
    height,
    maxHeight,
    reducedMargins = false,
    className,
    overlayBackground,
    isScrollable = true,
    returnFocusFunc,
    ...props
  } = _ref3;
  const fireAnalytics = (0, _analytics.default)("OverlayComponent");
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id,
    reducer: _index2.default,
    initialState: _index2.initialState
  });
  const overlayScrollRef = (0, _react.useRef)(null);
  const buttonRef = (0, _react.useRef)(null);
  const {
    showPage: isShowingPage,
    context
  } = select(_index2.getShowPageWithContext);
  const [, closeOverlay] = (0, _chronobreak.default)();
  const parentUnmountCallbacks = (0, _react.useRef)({});
  const onParentUnmount = function (key, func) {
    parentUnmountCallbacks.current[key] = func;
  };
  const handleCloseOverlay = (0, _react.useCallback)(function () {
    if (overlayMap.includes(id)) {
      overlayMap = overlayMap.filter(function (item) {
        return item !== id;
      });
    }
    dispatch(_index2.hidePage);
    if (!disableChronoBreak) closeOverlay(undefined);
    if (onClose) onClose();
  }, [closeOverlay, disableChronoBreak, dispatch, id, onClose]);
  const handleCloseButton = (0, _react.useCallback)(function () {
    handleCloseOverlay();
    fireAnalytics("close");
  }, [fireAnalytics, handleCloseOverlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Prevent multiple dependency from overtriggering Overlay analytics events
  (0, _react.useEffect)(function () {
    if (isShowingPage) {
      fireAnalytics("view");
      if (!window.LEXUS) {
        window.LEXUS = {};
      }
      window.LEXUS.closeOverlay = handleCloseOverlay;
    } else {
      if (Object.keys(parentUnmountCallbacks.current).length > 0) {
        Object.keys(parentUnmountCallbacks.current).forEach(function (i) {
          return parentUnmountCallbacks.current[i]();
        });
        parentUnmountCallbacks.current = {};
      }
    }
  }, [isShowingPage]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  (0, _react.useEffect)(function () {
    if (isShowingPage) {
      onOpen === null || onOpen === void 0 ? void 0 : onOpen(props);
      setTimeout(function () {
        overlayLockCounter++;
        if (!isSamePageOverlay) {
          (0, _scrollLock.disableBodyScroll)(overlayScrollRef.current, {
            allowTouchMove: function (el) {
              let element = el;
              do {
                if (element.classList && (element.classList.contains("slick-slider") || element.classList.contains("tippy-content") || element.classList.contains("is-scrollable"))) {
                  return true;
                }
                element = element.parentNode;
              } while (element);
              return false;
            }
          });
        }
      }, 0);
      if (buttonRef.current) {
        buttonRef.current.focus();
      }
    }
    return function () {
      // Todo: can we look into why we need two clear functions? it seems to fire both times.
      if (isShowingPage) {
        if (--overlayLockCounter <= 0) {
          (0, _scrollLock.clearAllBodyScrollLocks)();
        }
      }
    };
  }, [isShowingPage, onOpen, isSamePageOverlay]);
  const handleKeydown = (0, _react.useCallback)(function (e) {
    if (e.key === "Escape" && !e.target.matches("input")) {
      handleCloseButton();
    }
  }, [handleCloseButton]);
  const index = overlayMap.indexOf(id);
  return /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default.SubpageOverlayContainer, {
    $isShowingPage: isShowingPage,
    className: "overlay-component",
    "aria-roledescription": "overlay dialog",
    id: id,
    "aria-label": !props["aria-labelledby"] ? ariaLabel !== null && ariaLabel !== void 0 && ariaLabel.length ? `${ariaLabel} OVERLAY` : id : undefined,
    fixedHeight: fixedHeight,
    $isSamePageOverlay: isSamePageOverlay,
    $topPosition: topPosition,
    $layer: index,
    ...props,
    tabIndex: -1,
    children: isShowingPage && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactFocusLock.default, {
      returnFocus: returnFocusFunc ? returnFocusFunc : true,
      as: _index3.default.FocusLock,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default.SubpageOverlayBackground, {
        tabIndex: -1,
        $isSamePageOverlay: isSamePageOverlay,
        onClick: handleCloseButton,
        $overlayBackground: overlayBackground,
        children: "Close Overlay"
      }), !hideClose && closeOutside && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
        theme: buttonTheme,
        ref: buttonRef,
        onClick: handleCloseButton,
        iconColor: closeButtonIconColor,
        backgroundColor: closeButtonBackgroundColor,
        ariaLabel: !!(ariaLabel !== null && ariaLabel !== void 0 && ariaLabel.length) && ariaLabel ? `${ariaLabel} OVERLAY` : "OVERLAY"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index3.default.SubpageOverlay, {
        $isSamePageOverlay: isSamePageOverlay,
        $fit: lightbox ? "lightbox" : fit,
        $background: background,
        $color: color,
        onKeyDown: handleKeydown,
        $isDeepLink: true,
        $width: width,
        reducedMargins: reducedMargins,
        $height: height,
        $maxHeight: maxHeight,
        $borderRadius: borderRadius,
        className: className,
        tabIndex: -1,
        children: [!hideClose && !closeOutside && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
          theme: buttonTheme,
          ref: buttonRef,
          onClick: handleCloseButton,
          iconColor: closeButtonIconColor,
          backgroundColor: closeButtonBackgroundColor,
          ariaLabel: !!(ariaLabel !== null && ariaLabel !== void 0 && ariaLabel.length) && ariaLabel ? `${ariaLabel} OVERLAY` : "OVERLAY"
        }), isShowingPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default.PageContent, {
          $isIframe: !!src,
          $isScrollable: isScrollable,
          className: "overlay-component__is-scrollable is-scrollable",
          $pageSpacing: pageSpacing,
          ref: overlayScrollRef,
          $fit: lightbox ? "lightbox" : fit,
          $borderRadius: borderRadius,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(OverlayContext.Provider, {
            value: {
              handleCloseButton,
              onParentUnmount,
              background: background,
              color: color,
              scrollRef: overlayScrollRef,
              ...context
            },
            children: src ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default.Iframe, {
              src: src
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default.ChildrenWrapper, {
              pageSpacing: pageSpacing,
              children: _react.default.Children.map(children, function (child) {
                if (/*#__PURE__*/_react.default.isValidElement(child)) {
                  return /*#__PURE__*/_react.default.cloneElement(child, {
                    //@ts-ignore
                    handleParentUnmount: handleCloseButton,
                    onParentUnmount,
                    scrollRef: overlayScrollRef
                  });
                }
                return child;
              })
            })
          })
        })]
      })]
    })
  }), document.body);
};
var _default = exports.default = (0, _analytics.withAnalytics)((0, _index.withThemes)(OverlayComponent, colors))({
  _component: "OverlayComponent"
});